/* src/app/components/lead-details/member-view/member-view.component.css */
::ng-deep .ant-tabs-tab {
  background: rgba(30, 30, 30, 0.12) !important;
  color: #303030 !important;
  border-radius: 8px 8px 0 0 !important;
  transition: background 0.2s;
}
[nz-icon] {
  margin-right: 6px;
  font-size: 1.429rem;
  color: #3c86f5;
}
.drop-btn {
  cursor: pointer;
  padding: 7px;
  border-radius: 4px;
  margin-left: 0;
  border: 1px solid #cdc7c7;
  font-size: 1rem;
}
.ant-tabs {
  margin-bottom: 16px;
}
::ng-deep .ant-tabs-nav .ant-tabs-tab {
  margin: 0 2px !important;
  line-height: 1.2 !important;
  border-bottom: 2px solid transparent !important;
}
::ng-deep .ant-tabs-nav {
  border-bottom: 4px solid #0fb2a8 !important;
}
::ng-deep .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: break-word;
  -webkit-hyphens: none;
  hyphens: none;
  text-align: center;
  max-width: 160px;
  font-weight: 700 !important;
}
::ng-deep .ant-tabs-tab.ant-tabs-tab-active {
  background: #0fb2a8 !important;
  border-radius: 8px 8px 0 0 !important;
  box-shadow: 0 4px 16px 0 rgba(15, 178, 168, 0.18);
}
::ng-deep .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff !important;
  font-weight: 700;
}
::ng-deep .ant-tabs-ink-bar {
  height: 0 !important;
  background: transparent !important;
}
.action {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.actGRP {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
  padding-left: 5px;
  align-items: center;
}
.ppl-container-body {
  padding: 16px 24px 80px 24px;
  box-sizing: border-box;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.ppl-container {
  flex: 1;
  display: flex;
  min-height: 81vh !important;
  flex-direction: column;
}
.line1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  gap: 24px;
  margin-bottom: 24px;
  padding: 8px 0;
}
.page-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1.75rem;
  font-weight: 700;
  color: #303030;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.profile-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}
@media (max-width: 900px) {
  .line1 {
    flex-wrap: wrap;
    gap: 12px;
  }
  .action {
    order: 1;
  }
  .page-title {
    order: 2;
    font-size: 1.5rem;
    margin: 0;
    min-width: auto;
  }
  .actGRP {
    order: 3;
    flex-basis: 100%;
    margin-top: 4px;
    padding-left: 0;
    justify-content: flex-start;
  }
}
@media (max-width: 480px) {
  .page-title {
    font-size: 1.1rem;
    line-height: 24px;
    padding: 0 4px;
    min-width: 150px;
  }
  .profile-icon {
    width: 24px;
    height: 24px;
  }
}
.ico {
  filter: invert(0.75);
}
.ico:hover {
  cursor: pointer;
}
img {
  filter: invert(0.75);
}
/*# sourceMappingURL=member-view.component-EVCTNDVN.css.map */
